.style-controls {
  display: flex;
  gap: 0.5rem;
  pointer-events: all;
  text-decoration-line: none;
  padding: 0.2rem 0.5rem;
  justify-content: flex-end;
  align-items: center;
  background: var(--color-bg-primary);
  //background: var(--color-gray-100);
  opacity: 0.9;
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  top: 0.5rem;
  right: 0.5rem;
  transition: top 0.2s ease-in-out;

  :global {
    .geolocator-search {
      background-color: var(--color-bg-primary);
      //background-color: var(--color-gray-100);
      padding: 0.5rem 2rem;
      border-radius: var(--radius-md);
      margin-bottom: 0;
    }

    .geolocator-search .geolocator-input {
      background-color: var(--color-bg-primary);
      border: 1px solid #ccc;
      padding: 0.5rem;
      width: 100%;
      border-radius: var(--radius-md);
    }
  }

}


.font-size-controls {
  display: flex;
  align-items: center;
  text-decoration-line: none;
  gap: 0.2rem;
  padding-right: 0.25rem;

  > * {
    padding-right: 0.25rem;
  }
}

.plot-calendar {
  border-top: 1px solid #bec8c6;
}

.calendar-controls {
  font-weight: normal;
}

.calendar-controls_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 12px;
}

.calendar-header {
  height: 40px;
}

.copy-controls {
  background-color: white;
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  padding: 0.4rem 0;
  pointer-events: all;

  position: relative;

  > button {
    display: grid;
    grid-template-columns: auto 1rem;
    align-items: center;
    padding: 0.4rem 0.6rem;
    cursor: pointer;

    &:disabled {
      pointer-events: none;
      color: #c7c7c7;
    }

    &:hover {
      background-color: #f2f2f2;
    }
  }
}

.location-options-menu {
  // !important is needed to override icon-button2
  height: inherit !important;
  width: inherit !important;
  color: inherit !important;
  :first-child {
    font-size: inherit
  }
}
